import type { Database } from '@/integrations/supabase/types';

type KosherStatus = Database['public']['Enums']['kosher_status'];

export const KOSHER_STATUS_LABELS: Record<string, string> = {
  'unknown': 'Inconnu',
  'kosher': 'Casher',
  'kosher_dairy': 'Cacher Halavie',
  'kosher_meat': 'Cacher Bassari',
  'kosher_pareve': 'Casher Parve',
  'glatt_kosher': 'Glatt Casher',
  'not_kosher': 'Non Casher',
};

export const getKosherStatusLabel = (status: string): string => {
  return KOSHER_STATUS_LABELS[status] || status;
};

export const KOSHER_OPTIONS: { value: KosherStatus; label: string }[] = [
  { value: 'unknown', label: 'Inconnu' },
  { value: 'kosher', label: 'Casher' },
  { value: 'kosher_dairy', label: 'Cacher Halavie' },
  { value: 'kosher_meat', label: 'Cacher Bassari' },
  { value: 'kosher_pareve', label: 'Casher Parve' },
  { value: 'glatt_kosher', label: 'Glatt Casher' },
  { value: 'not_kosher', label: 'Non Casher' },
];

// Kosher status options for filtering (excluding unknown and not_kosher)
export const KOSHER_FILTER_OPTIONS: { value: KosherStatus; label: string }[] = [
  { value: 'kosher_meat', label: 'Bassari' },
  { value: 'kosher_dairy', label: 'Halavie' },
  { value: 'kosher_pareve', label: 'Parve' },
  { value: 'glatt_kosher', label: 'Glatt Casher' },
  { value: 'kosher', label: 'Casher' },
];

// Common kosher authorities - Beth Din grouped together
export const KOSHER_AUTHORITIES: { value: string; label: string }[] = [
  { value: 'beth din', label: 'Beth Din' },
  { value: 'loubavitch', label: 'Loubavitch' },
  { value: 'rottenberg', label: 'Rav Rottenberg' },
  { value: 'rav katz', label: 'Rav Katz' },
  { value: 'rav weill', label: 'Rav Weill' },
  { value: 'consistoire', label: 'Consistoire' },
  { value: 'crc', label: 'CRC Paris' },
];
